module.exports = [
    "دنیای هوشمند رشد کودک - سامانه‌ی آنلاین کودکان",
    'کدپستی: ۱۴۳۹۹۵۷۱۳۱',
    'شماره تماس: ۶۶۳۶۳۳۷۳–۰۲۱',
    'آدرس: تهـــران، خیـــابـــان آزادی، خیـــابـــان حبیب الله خیابان قاسمی،جنب جهاد دانشگاهی شریف',
    'تمامی حقوق این وبسایت برای مهروبو محفوظ می باشد.'
]